import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puedo hacer SAINT® si no quiero tomar más antidepresivos?",
    answer:
      "SAINT® no requiere estar tomando antidepresivos en el momento del tratamiento. La decisión sobre la medicación se toma con el psiquiatra. SAINT® es una opción para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos.",
  },
  {
    question: "¿SAINT® significa que no tendré que tomar más medicación?",
    answer:
      "No necesariamente. La decisión sobre la medicación se toma con el psiquiatra en función de las circunstancias individuales. SAINT® no garantiza la suspensión de la medicación.",
  },
];

export const esWithoutMoreMedication = makeEsArticle({
  slug: "depression-treatment-without-more-medication",
  title: "Tratamiento de la depresión sin más medicación",
  description:
    "Si no quiere tomar más antidepresivos, SAINT® es una opción para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No requiere estar tomando antidepresivos durante el tratamiento.",
  h1: "Tratamiento de la depresión sin más medicación",
  breadcrumbLabel: "Sin más medicación",
  shortAnswer:
    "Si no quiere tomar más antidepresivos, SAINT® es una opción para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® no requiere estar tomando antidepresivos en el momento del tratamiento. La decisión sobre la medicación se toma con el psiquiatra. SAINT® no garantiza la suspensión de la medicación.",
  keyTakeaways: [
    "SAINT® es una opción para el trastorno depresivo mayor.",
    "Está indicado para adultos que no han mejorado con antidepresivos.",
    "No requiere estar tomando antidepresivos durante el tratamiento.",
    "La decisión sobre la medicación se toma con el psiquiatra.",
    "SAINT® no garantiza la suspensión de la medicación.",
  ],
  sections: [
    {
      heading: "Si no quiere tomar más antidepresivos",
      paragraphs: [
        "Algunas personas prefieren no tomar más antidepresivos, ya sea por efectos secundarios, falta de alivio suficiente o preferencia personal. SAINT® es una opción de tratamiento no invasivo que no requiere estar tomando antidepresivos en el momento del tratamiento.",
      ],
    },
    {
      heading: "La decisión sobre la medicación",
      paragraphs: [
        "La decisión de continuar, suspender o iniciar medicación se toma con el psiquiatra. SAINT® no garantiza la suspensión de la medicación; la decisión depende de las circunstancias individuales.",
      ],
    },
    {
      heading: "Cómo empezar",
      paragraphs: [
        "El primer paso es una consulta con nuestro equipo clínico para confirmar la elegibilidad. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
